<template>
  <div class="container">
    <PageHeader current="aboutus" />
    <div class="main-container">
      <div class="w1200 f6 clearFix">
        <div class="fl about_left">
          <IntroNav current="aboutus" />
        </div>
        <div class="fr about_right">
          <div class="c-box">
            <img
              src="@/assets/logo.png"
              alt=""
              width="200"
              style="margin-bottom: 20px"
            />
            <p>
              晟行汽车隶属于北京晟行科技有限公司，是以精准互联网营销为基础打造的汽车综合网站，我们致力于帮助购车用户解决选车难、询价繁、价格虚等传统买车难题。晟行汽车将通过全新的互联网模式，真正帮助消费者完成选车、看车、买车一站式购车体验。
            </p>
          </div>
        </div>
      </div>

      <!-- 底部介绍 -->
      <service-intro></service-intro>
    </div>

    <Footer />
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import ServiceIntro from "@/components/index/ServiceIntro";
import Footer from "@/components/Footer";
import IntroNav from "@/components/IntroNav";

export default {
  name: "Index",
  components: {
    PageHeader,
    ServiceIntro,
    Footer,
    IntroNav,
  },
  data() {
    return {};
  },
  computed: {},
  beforeCreadted() {},
  created() {
    this.getData();
  },
  beforeDestroy() {},
  methods: {
    getData() {},
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  overflow: hidden;
  .about_left {
    width: 320px;
    padding: 40px;
  }
  .about_right {
    min-height: 400px;
    width: 880px;
    background: #fff;
    padding: 40px;
  }
}
</style>

